import { ROUTES } from "../../constants/routes";
import { Component, inject } from "@angular/core";
import { RouterLink } from "@angular/router";
import { Navbar } from "../../components/navbar/navbar";
import { Breadcrumb } from "../../components/breadcrumb/breadcrumb";
import { Footer } from "../../components/footer/footer";
import { SeoService } from "../../services/seo.service";
import { SITE } from "../../constants/site";
import { breadcrumbSchema, webPageSchema } from "../../helpers/structured-data";

@Component({
  selector: "app-terms",
  imports: [RouterLink, Breadcrumb, Navbar, Footer],
  templateUrl: "./terms.html",
  styleUrl: "./legal.scss"
})
export class Terms {
  readonly routes = ROUTES;
  private readonly seo = inject(SeoService);
  readonly site = SITE;
  readonly updated = "August 2026";

  ngOnInit(): void {
    this.seo.apply({
      title: "Terms of Service | VerifyDeceased Platform Terms",
      description:
        "VerifyDeceased terms of service covering acceptable use, verification data, pricing and billing, refunds, cancellation, dispute resolution and liability.",
      path: "/terms",
      keywords:
        "VerifyDeceased terms of service, terms and conditions, acceptable use, refund policy, cancellation policy, dispute resolution",
      structuredData: [
        breadcrumbSchema([
          { name: "Home", path: "/" },
          { name: "Terms of Service", path: "/terms" }
        ]),
        webPageSchema({
          name: "Terms of Service",
          description:
            "VerifyDeceased terms of service covering acceptable use, verification data, pricing and billing, refunds, cancellation and dispute resolution.",
          path: "/terms"
        })
      ]
    });
  }
}
